import { Button, FormControl, TextField, Typography } from '@mui/material';
import { LayerUITitle } from 'entities/prize';
import React, { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  MGetAdminCompetitionPrizePlace,
  useAddCoinsMutation,
  usePatchAwardDeliveryInfoMutation,
} from 'entities/competitions-b2b';
import { Box } from '@mui/system';
import { useAppDispatch } from 'app/store';
import { useResponseHandler } from 'shared/hooks';
import { RejectAwardDrawerFeature } from '../rejectAward';
import { setDrawerName, setDrawerOpen } from '../../ui/model/uiSlice';
import { useDeliveryInfoFormGeneration } from './lib/hooks';
import { IDeliveryInfo } from './types';

const DeliveryInfoFeature: FC<IDeliveryInfo> = ({ coinsFlow, prizePlace, setShowParcelDialog }) => {
  const dispatch = useAppDispatch();
  const { control, handleSubmit } = useForm<
    Omit<MGetAdminCompetitionPrizePlace.Response['delivery_info'], 'id' | 'created_at'>
  >({ defaultValues: prizePlace.delivery_info || {} });
  const deliveryItems = useDeliveryInfoFormGeneration(prizePlace);
  const [patchAwardDeliveryInfo] = usePatchAwardDeliveryInfoMutation();
  const [addCoins, { error: addCoinsError, data: addCoinsData }] = useAddCoinsMutation();

  useResponseHandler(addCoinsData, addCoinsError, 'Спасибо! Монеты начислены', 'При начислении монет произошла ошибка');

  const submit = handleSubmit((data) => {
    patchAwardDeliveryInfo({ ...data, award_place_id: prizePlace.id } as any);
  });

  const addCoinsFn = () => {
    addCoins({ awardPlaceId: prizePlace.id });
  };

  return (
    <Box sx={{ width: '100%' }}>
      {!coinsFlow ? (
        <FormControl sx={{ width: '100%' }}>
          <LayerUITitle>Данные доставки:</LayerUITitle>
          {deliveryItems.map((item) => (
            <>
              <Typography
                color="#888F99"
                fontSize={13}
                fontWeight="500"
              >
                {item.title}
              </Typography>
              <Controller
                // TODO
                name={item.name as never}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <TextField
                    variant="standard"
                    value={value}
                    size="small"
                    sx={{ width: 425, mb: 4 }}
                    onChange={onChange}
                    placeholder={item.title}
                  />
                )}
              />
            </>
          ))}
          <Button
            sx={{ width: 125, backgroundColor: '#4781DA' }}
            variant="contained"
            onClick={submit}
          >
            Сохранить
          </Button>
        </FormControl>
      ) : null}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        {prizePlace.status === 3 ? <RejectAwardDrawerFeature awardPlaceId={prizePlace.id} /> : null}
        {/* {prizePlace.status === 3 ? ( */}
        <>
          <Button
            sx={{ fontSize: 16, textTransform: 'none', backgroundColor: '#4781DA', mr: 2 }}
            variant="contained"
            onClick={coinsFlow ? addCoinsFn : () => setShowParcelDialog(true)}
          >
            {coinsFlow ? 'Начислить монеты' : 'Отправить посылку'}
          </Button>
          <Button
            sx={{ fontSize: 16, textTransform: 'none' }}
            variant="outlined"
            onClick={() => {
              dispatch(setDrawerName('REJECT'));
              dispatch(setDrawerOpen(true));
            }}
          >
            Отменить вознаграждение
          </Button>
        </>
        {/* ) : null} */}
        {prizePlace.status === 6 ? (
          <Button
            sx={{ fontSize: 16, textTransform: 'none' }}
            disabled
          >
            Награда отправлена
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export { DeliveryInfoFeature };
